const footerLinks = [
    {
        id: "l_1",
        title: "الصفحة الرئيسية",
        url: "/"
    },
    {
        id: "l_2",
        title: "صفحة المنتج",
        url: "/product"
    },
    {
        id: "l_3",
        title: "نتائج البحث",
        url: "/search"
    },
    {
        id: "l_4",
        title: "السلة",
        url: "/cart"
    },
    {
        id: "l_5",
        title: "السلة فارغة",
        url: "/cart-empty"
    },
    {
        id: "l_6",
        title: "اكمل الطلب",
        url: "/complete-order"
    },
    {
        id: "l_7",
        title: "المستخدم",
        url: "/account"
    },
    {
        id: "l_8",
        title: "بيانات المستخدم",
        url: "/user"
    },
    {
        id: "l_9",
        title: "الطلبات",
        url: "/orders"
    },
    {
        id: "l_10",
        title: "ملخص الطلب",
        url: "/order-summary"
    },
    {
        id: "l_11",
        title: "قائمة الأمنيات",
        url: "/wishlist"
    },
    {
        id: "l_12",
        title: "من نحن",
        url: "/about-us"
    }
];

export default footerLinks;
